import { Component, Inject } from '@angular/core';
import { AppMaterialModule } from '../../../app-material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmailService } from '../../services/email/email.service';
import { ApiResult } from '../../models/api-result.models';
import { ClienteService } from '../../services/cliente/cliente.service';
import { AuthService } from '../../services/auth.service';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';
import { setTermosAceitosLocal } from '../../constants/termos-uso.constants';

@Component({
    selector: 'app-termos-de-uso-dialog',
    standalone: true,
    imports: [AppMaterialModule, TranslocoPipe],
    providers: [EmailService, ClienteService, AuthService, ...provideTranslocoScope('termosUso')],
    templateUrl: './termos-de-uso-dialog.component.html',
    styleUrl: './termos-de-uso-dialog.component.scss',
})
export class TermosDeUsoDialogComponent {
    isScrolledToEnd = false;
    agreed = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: Record<string, unknown>,
        private dialogRef: MatDialogRef<TermosDeUsoDialogComponent>,
        private emailService: EmailService,
        private clienteService: ClienteService,
        private authService: AuthService,
    ) {}

    fechar(aceitar: boolean) {
        if (aceitar) {
            this.clienteService.updateVsualizouTermosUso().subscribe({
                next: (_apiResult) => {
                    this.persistTermosAceitosLocal();
                    this.emailService.sendEmailByTemplate('termos-de-uso').subscribe({
                        next: (_apiResult: ApiResult) => {
                            this.dialogRef.close();
                        },
                        error: () => {
                            this.dialogRef.close();
                        },
                    });
                },
                error: () => {
                    // PUT falhou — modal permanece aberto para nova tentativa.
                },
            });
        } else {
            this.dialogRef.close();
        }
    }

    private persistTermosAceitosLocal(): void {
        const clienteId = Number(this.authService.cliente?.id);
        if (Number.isFinite(clienteId) && clienteId > 0) {
            setTermosAceitosLocal(clienteId);
        }

        if (this.authService.cliente) {
            this.authService.cliente.aceitou_termos_de_uso = 1;
        }
    }

    onScroll(event: Event): void {
        const target = event.target as HTMLElement;
        const isAtBottom = target.scrollHeight - target.scrollTop === target.clientHeight;

        if (isAtBottom) {
            this.isScrolledToEnd = true;
        }
    }
}
